import type { PersonFormDirty, PersonFormFieldKey } from "./personFormTypes";

/** camelCase / PascalCase → título legible (p. ej. lastName → Last Name). */
export function defaultLabelFromFieldKey(key: string): string {
  const spaced = key.replace(/([A-Z])/g, " $1").trim();
  return spaced
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}

export const PERSON_FIELD_LABEL_OVERRIDES: Partial<
  Record<PersonFormFieldKey, string>
> = {
  honorary: "Honorary Title",
  firmEmail: "Firm Email",
  firm: "Firm",
  mainOffice: "Main Office",
  additionalOffices: "Additional Offices",
  isAttorney: "Is Attorney",
  isSearchable: "Is Searchable",
  isWsgMember: "Is WSG Member",
  hasAssistant: "Has Assistant",
  unlistedTitleToggle: "Unlisted Title",
  userId: "User ID",
  barAdmissions: "Bar Admissions",
  areasOfPractice: "Areas of Practice",
  aopExpertiseIds: "My Areas of Practice",
  yearJoinedFirm: "Year Joined Firm",
  industryOrganizationAffiliation: "Industry / Organization Affiliation",
};

export function labelForPersonFieldKey(key: PersonFormFieldKey): string {
  return PERSON_FIELD_LABEL_OVERRIDES[key] ?? defaultLabelFromFieldKey(key);
}

/** Etiquetas únicas para campos dirty, orden alfabético por texto mostrado. */
export function getDirtyPersonFieldLabels(
  dirtyFields: PersonFormDirty | undefined
): string[] {
  if (!dirtyFields) {
    return [];
  }
  const keys = (Object.keys(dirtyFields) as PersonFormFieldKey[]).filter(
    (k) => dirtyFields[k]
  );
  const labels = keys.map((k) => labelForPersonFieldKey(k));
  const unique = [...new Set(labels)];
  unique.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
  return unique;
}
